import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue';
import useContext from '@/composables/useContext';
import { imageFit } from '@distancify/drapejs-storyblok';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
  name: 'Button'
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  block: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props



const { resolveLink } = useContext();

const pictogram = computed(() => imageFit(props.block.pictogram, { width: 20, height: 20 }));


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _unref(resolveLink)(() => props.block.link)?.url,
    target: _unref(resolveLink)(() => props.block.link)?.isExternal ? '_blank' : '_self',
    class: _normalizeClass(`button button--${props.block.style}`)
  }, {
    default: _withCtx(() => [
      (_unref(pictogram)?.filename)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(pictogram).filename,
            height: "20",
            width: "20",
            class: "button__pictogram"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(props.block.label), 1)
    ]),
    _: 1
  }, 8, ["to", "target", "class"]))
}
}

})